<template>
	<div class="footer">
		<div class="footer-row">
			<div class="footer-row-item">
				<div class="title">产品服务</div>
				<p>慧年智慧健康养老平台</p>
				<p>慧年健康养老APP</p>
			</div>
			<div class="footer-row-item">
				<div class="title">帮助中心</div>
				<p>下载中心</p>
			</div>
			<div class="footer-row-item">
				<div class="title">联系我们</div>
				<p>联系电话：023-67144555</p>
				<p>渠道合作：023-67144555</p>
				<p>地址：重庆市渝北区仙桃数据A11-2层</p>
			</div>
		</div>
		<p class="al">
			<span>©2020-2021 慧年健康科技（重庆）有限公司</span>
			<img src="../assets/icon.png" alt="" />
			<a href="https://beian.miit.gov.cn/#/Integrated/index">渝ICP备2022010029号</a>
		</p>
	</div>
</template>

<script>
export default {
	// 底部
	name: 'footer',
}
</script>

<style lang="scss" scoped>
.footer {
	width: 100%;
	height: 230px;
	background: #30373e;
	font-size: 12px;
	color: #939599;
	padding-top: 30px;
	box-sizing: border-box;
	&-row {
		width: 60%;
		height: calc(100% - 60px);
		margin: 0 auto;
		display: flex;
		&-item {
			flex: 1;
			text-align: left;
			.title {
				font-size: 14px;
				color: #ffffff;
				margin-top: 10px;
			}
		}
	}
	.al {
		display: flex;
		align-items: center;
		justify-content: center;
		img {
			width: 15px;
			margin: 0 5px;
		}
		a {
			color: #939599;
			text-decoration: none;
		}
		a:hover {
			color: #05be00;
		}
	}
}
</style>
